
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { Typography, Paper, List, ListItemText, ListItem } from '@material-ui/core';
import { connect } from 'react-redux';
import * as H from 'history';

import { siteInfoListOperations } from '../redux/modules';
import { IAppState } from '../redux/modules';
import { SiteInfoListState } from '../redux/modules/siteInfoList';
import { NavLink } from 'react-router-dom';
import { CloseBackButton } from './parts/CloseBackButton';

interface OwnProps {
  listSiteInfo: () => void;
  clear: () => void;
  siteInfoList: SiteInfoListState;
  history: H.History;
}

class SelectSitePage extends React.Component<OwnProps>{
  componentWillMount() {
    this.props.listSiteInfo();
  }
  render() {
    return (
    <div>
      <Typography variant="h6">対象の工事現場を選択</Typography>
      <Paper style={{ padding: '10px' }}>
        <List>
            {this.props.siteInfoList.items.map((item, index) => {
              return (
                <NavLink
                  key={`link_${index}`}
                  style={{textDecoration: 'none', color: 'unset'}}
                  to={`/kansatsukiroku/${item.koujiBangou}`}
                >
                  <ListItem
                    button
                    divider
                    key={item.koujiBangou}
                  >
                    <ListItemText
                      primary={item.name}
                      secondary={item.koujiBangou}
                    />
                  </ListItem>
                </NavLink>
              );
            })}
        </List>
      </Paper>
      <CloseBackButton history={this.props.history} />
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    listSiteInfo: () => {
      siteInfoListOperations.list()(dispatch);
    },
    clear: () => {
      siteInfoListOperations.clear()(dispatch);
    },
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    siteInfoList: appState.siteInfoList,
    user: appState.user
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectSitePage);





// WEBPACK FOOTER //
// ./src/components/SelectSitePage.tsx